<template lang="pug">
  .feedback#surveysQuiz(v-if="experiences" :style="{ maxHeight: heightContent }")
    img.feedback__close(v-if="!showMessageResponse" @click="closeSurvey" alt="Botão fechar" src="@/assets/close.svg")

    .feedback__header(v-if="!loading && !showMessageResponse")
      h2.feedback__title Como foi a sua experiência de compra em nosso site?
      .feedback__expression-icons
        a.feedback__expression-icons__circle-face.feedback__expression-icons__circle-face--good(:class="{'feedback__expression-icons__circle-face--noSelected': experienceSelected && experienceSelected !== 1}" @click="openQuestionAndAnswers(1)")
        a.feedback__expression-icons__circle-face.feedback__expression-icons__circle-face--medium(:class="{'feedback__expression-icons__circle-face--noSelected': experienceSelected && experienceSelected !== 2}" @click="openQuestionAndAnswers(2)")
        a.feedback__expression-icons__circle-face.feedback__expression-icons__circle-face--bad(:class="{'feedback__expression-icons__circle-face--noSelected': experienceSelected && experienceSelected !== 3}" @click="openQuestionAndAnswers(3)")
    .feedback__content(v-if="showQuestionsAndAnswers && !loading")
      h3.feedback__content--subtitle {{ experience.questions[0].description }}
      .feedback__content__options(v-for="answer in experience.questions[0].answers" @click="chooseAnswer(answer.uuid)")
        input.feedback__content__options__inputRadio(type="radio" :id="answer.uuid" :name="answer.uuid" :checked="chosenAnswer === answer.uuid")
        i.feedback__content__options__icon
        label.feedback__content__options__label(:for="answer.uuid") {{ answer.description }}

      textarea.feedback__content--textarea(name="comment" id="comment" v-model="feedbackComment" placeholder="Deixe um comentário" maxlength="280")
      button.feedback__content--action(@click="sendFeedback") Enviar
    .feedback__message-response(v-if="!loading && showMessageResponse")
      h2.feedback__message-response--title(v-html="messageResponseFeedback")
      button.feedback__message-response--action(@click="closeSurvey") Fechar

    loader(v-if="loading" text="Enviando avaliação")
</template>

<script>
import { mapState } from 'vuex'
import { getSurveys, sendSurveyResponse } from '@/api/services'
import Loader from '@/components/Loader'

export default {
  name: 'Feedback',
  components: {
    Loader
  },
  data () {
    return {
      experiences: [],
      loading: false,
      experience: null,
      experienceSelected: 0,
      heightContent: '',
      chosenAnswer: '',
      showQuestionsAndAnswers: false,
      showMessageResponse: false,
      feedbackComment: '',
      messageResponseFeedback: 'Avaliação recebida. Obrigado&nbsp;:)'
    }
  },
  created () {
    getSurveys()
      .then(response => {
        this.experiences = response.data.experiences
      })
      .catch(error => {
        this.$sentry.logWithContext({
          ctx: {
            label: 'getSurveys',
            error
          },
          error
        })
      })
  },
  computed: {
    ...mapState('payment', ['planUuid'])
  },
  methods: {
    openQuestionAndAnswers (option) {
      this.experienceSelected = option

      this.chosenAnswer = ''
      this.experience = this.experiences[--option]

      if (!this.showQuestionsAndAnswers) {
        this.heightContent = `${this.$el.clientHeight + 580}px`
      }

      this.showQuestionsAndAnswers = true
    },
    chooseAnswer (answer) {
      this.chosenAnswer = answer
    },
    sendFeedback () {
      const data = {
        experienceUuid: this.experience.uuid,
        answerUuid: this.chosenAnswer,
        comment: this.feedbackComment
      }

      this.loading = true
      this.heightContent = ''

      sendSurveyResponse(data, this.planUuid)
        .then(response => {
          const answerSelected = this.experience.questions[0].answers.find(answer => answer.uuid === data.answerUuid)
          this.tracking(this.experience.description.toLowerCase())
          this.tracking((answerSelected && answerSelected.description) || 'n/d')

          this.loading = false
          this.showQuestionsAndAnswers = false
          this.showMessageResponse = true
          this.heightContent = `${320}px`
        })
        .catch(error => {
          this.$sentry.logWithContext({
            ctx: {
              label: 'sendSurveyResponse',
              error
            },
            error
          })

          this.tracking('erro')

          this.loading = false
          this.showQuestionsAndAnswers = false
          this.showMessageResponse = true
          this.messageResponseFeedback = 'Ops! Ocorreu um erro.'
          this.heightContent = `${320}px`
        })
    },
    closeSurvey () {
      this.experiences = null
    },
    tracking (value) {
      window.dataLayer.push({
        event: 'viagem-pesquisa',
        gaEventAction: value,
        gaEventCategory: 'resposta-pesquisa',
        gaEventLabel: this.$route.params.planUuid
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";

.feedback {
  width: 100%;
  max-width: 272px;
  max-height: 211px;
  margin: 0 auto;
  transition: visibility 0s, opacity 0.5s linear;
  transition: max-height 300ms ease-in-out;
  overflow: hidden;

  @media only screen and (min-width: 768px) {
    max-width: 320px;
  }

  &__close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  &__header {
    margin-top: 32px;
    margin-bottom: 44px;
  }

  &__title {
    font-size: 18px;
    font-weight: bold;
    color: $dark-slate-blue;
    text-align: center;
    padding: 20px;

    @media only screen and (min-width: 768px) {
      font-size: 20px;
    }
  }

  &__expression-icons {
    width: 100%;
    display: flex;
    justify-content: center;

    &__circle-face {
      width: 46px;
      height: 44px;
      border-radius: 100%;
      margin: 0 20px 0;
      position: relative;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: center;

      &--noSelected {
        opacity: .4;
      }
    }

    &__circle-face--good {
      background-image: url('~@/assets/icons/smile-good.svg');
    }
    &__circle-face--medium {
      background-image: url('~@/assets/icons/smile-neutral.svg');
    }

    &__circle-face--bad {
      background-image: url('~@/assets/icons/smile-bad.svg');
    }

    &--opacity {
      opacity: 0.4;
    }
  }

  &__content {
    width: 100%;
    text-align: center;
    margin-bottom: 24px;
    margin-top: 32px;

    @media only screen and (min-width: 425px) {
      margin-bottom: 48px;
      margin-top: 40px;
    }

    &--subtitle {
      font-size: 16px;
      font-weight: bold;
      color: $dark-slate-blue;
      text-align: left;
      margin-bottom: 24px;
    }

    &__options {
      align-items: center;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      font-size: 16px;
      line-height: 1.5;
      margin-bottom: 10px;
      padding: 10px 0;
      position: relative;
      text-align: left;

      &__inputRadio {
        position: absolute;
        left: -9999px;
      }

      input[type=radio]:checked ~ &__bg {
        background-color: #d8d8d8;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }

      &__icon {
        width: 19px;
        height: 19px;
        border-radius: 100%;
        position: relative;
        background-color: #d8d8d8;

        input[type=radio]:checked ~ &:after {
          background-color: #767d83;
          border-radius: 100%;
          content: '';
          left: calc(50% - 4px);
          height: 8px;
          position: absolute;
          top: calc(50% - 4px);
          width: 8px;
        }
      }

      &__label {
        cursor: pointer;
        flex: 1;
        font-family: $rubik-font-family;
        padding-left: 10px;
        position: relative;
        z-index: 1;
        font-size: 16px;
        cursor: pointer;

        b {
          font-weight: 500;
        }

        &__icon {
          position: absolute;
          top: -4px;
          right: -20px;
          width: 32px;
          height: 32px;
          background-image: url('~@/assets/arrow-right.svg');

          @media screen and (min-width: 375px) {
            right: 0;
          }
        }

        b {
          font-weight: 500;
        }

        &__icon {
          position: absolute;
          top: -4px;
          right: -20px;
          width: 32px;
          height: 32px;
          background-image: url('~@/assets/arrow-right.svg');

          @media screen and (min-width: 375px) {
            right: 0;
          }
        }
      }
    }

    &--textarea {
      width: 204px;
      height: 88px;
      border-radius: 8px;
      border: solid 1px rgba(165, 173, 180, 0.65);
      padding: 16px 29px;

      @media only screen and (min-width: 668px) {
        width: 310px;
        height: 125px;
      }

      &::placeholder {
        font-family: Rubik;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        color: #d8d8d8;
      }
    }

    &--action {
      width: 100%;
      max-width: 182px;
      background-color: $color-purple-heart;
      border-radius: 28px;
      padding: 10px 60px;
      color: $white;
      text-transform: uppercase;
      border: none;
      box-shadow: none;
      font-size: 14px;
      cursor: pointer;
      margin-top: 24px;
      border: none;

      @media only screen and(min-width: 768px) {
        max-width: 310px;
        margin-top: 32px;
      }

      &:disabled {
        opacity: 0.4;
      }
    }
  }

  &__message-response {
    text-align: center;
    margin: 64px auto 64px;

    &--title {
      font-size: 18px;
      color: #264261;
      text-align: center;

      @media only screen and (min-width: 426px) {
        font-size: 24px;
      }
    }

    &--action {
      width: 100%;
      max-width: 182px;
      border-radius: 28px;
      padding: 11px 60px;
      color: $white;
      background-color: $color-purple-heart;
      cursor: pointer;
      text-transform: uppercase;
      margin-top: 23px;
      border: none;

      @media only screen and (min-width: 768px) {
        max-width: 310px;
        margin-top: 40px;
      }
    }
  }
}

</style>
